import { useMediaQuery } from '@mui/material';
import { EBreakpoints } from '@theme/theme';

export const useIsMobile = () => {
  const isMobile = useMediaQuery(`(max-width:${EBreakpoints.desktop - 0.5}px)`);

  return { isMobile };
};
